import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  SCHEDULE_ADMIN_REPORTS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchAdminScheduleReports = async (payload) => {
  if (payload.filterParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.ADMIN_SCHEDULE_REPORTS}?${payload.filterParams}`);
  }
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  return axiosAuthInstance.get(`${API_END_POINTS.ADMIN_SCHEDULE_REPORTS}${query}${sorting}`);
};

const addAdminScheduleReport = async ({ params }) => axiosAuthInstance.post(API_END_POINTS.ADMIN_SCHEDULE_REPORTS, params);

const deleteAdminScheduleReport = async (gid) => axiosAuthInstance.delete(`${API_END_POINTS.ADMIN_SCHEDULE_REPORTS}/${gid}`);

export function* getAdminScheduleReports(action) {
  try {
    const { data: { entity } } = yield call(fetchAdminScheduleReports, action.payload);
    yield put({ type: SCHEDULE_ADMIN_REPORTS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: SCHEDULE_ADMIN_REPORTS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}

export function* addAdminScheduleReports(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(addAdminScheduleReport, action.payload);
    const { data: { entity } } = yield call(fetchAdminScheduleReports, action.payload);
    yield put({ type: SCHEDULE_ADMIN_REPORTS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.REPORT.GENERATE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* deleteAdminScheduleReports(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(deleteAdminScheduleReport, action.payload);
    const { data: { entity } } = yield call(fetchAdminScheduleReports, action.payload);
    yield put({ type: SCHEDULE_ADMIN_REPORTS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.REPORT.DELETE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
